import { render, staticRenderFns } from "./tilting.vue?vue&type=template&id=58c32b40&scoped=true&"
import script from "./tilting.vue?vue&type=script&lang=js&"
export * from "./tilting.vue?vue&type=script&lang=js&"
import style0 from "./tilting.vue?vue&type=style&index=0&id=58c32b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c32b40",
  null
  
)

export default component.exports